import { Trash2, User, UserCog, Button } from "../../../ui";
import { useContext } from "react";
import { Context } from "../../../../context/Context";
import { useAccess } from "../../../../access/hooks/useAccess";
import { Checkbox } from "../../../ui/Checkbox";

const PRIORITIES = ["low", "normal", "high", "urgent", "critical"];

export default function TicketList({
  tickets,
  selectedTicket,
  bulkMode,
  selectedIds,
  setSelectedIds,
  openTicket,
  onDelete,
  getCustomFields,
  t,
}) {
  const { lang } = useContext(Context);
  const { can, has } = useAccess();
  const isStoreSide = can("support.ticket.clientSide");

  return (
    <div className="support-ticket-list">
      {tickets.map((ticket) => {
        const priority = PRIORITIES.includes(ticket?.priority) ? ticket.priority : "";
        const isSelected = selectedTicket?._id === ticket?._id;
        const label = ticket?.ticketNumber || ticket?.title || ticket?._id;

        return (
          <div
            key={ticket?._id}
            className={`support-ticket-row ${priority} ${isSelected ? "selected" : ""}`}
            role="button"
            tabIndex={0}
            aria-pressed={isSelected}
            onClick={() => openTicket(ticket)}
            onKeyDown={(e) => {
              // Keys on nested controls (checkbox, delete) aren't row toggles.
              if (e.target !== e.currentTarget) return;
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                openTicket(ticket);
              }
            }}
          >
            {bulkMode && (
              <div onClick={(e) => e.stopPropagation()}>
                <Checkbox
                  checked={selectedIds.includes(ticket._id)}
                  label={<span className="support-visually-hidden">{label}</span>}
                  onChange={(e) => {
                    if (e.target.checked) {
                      setSelectedIds((prev) => [...prev, ticket._id]);
                    } else {
                      setSelectedIds((prev) =>
                        prev.filter((id) => id !== ticket._id),
                      );
                    }
                  }}
                />
              </div>
            )}

            <div className="ticket-id">
              <div className="ticket-title">
                {ticket?.storeId?.id || "-"}{" "}
                {ticket?.storeId?.businessName || "-"}
              </div>
              {ticket?.ticketNumber || ticket?._id}
            </div>

            <div className="ticket-info">
              <div>
                <div className="ticket-title">{ticket?.title || "-"}</div>
                {/* Priority as text too, not only the coloured border. */}
                {!isStoreSide && priority && (
                  <div className="ticket-title">
                    <span className={`urgent-label priority-${priority}`}>
                      {t[priority]}
                    </span>
                  </div>
                )}
              </div>

              <div className="ticket-sub">
                {getCustomFields(ticket)
                  .map((field) => field.value)
                  .join(" - ")}
              </div>
            </div>

            <div className="ticket-meta">
              <User size={12} aria-hidden="true" />
              <span>{ticket?.createdBy?.name || "—"}</span>
            </div>

            <div className="ticket-meta">
              <UserCog size={12} aria-hidden="true" />
              <span>{ticket?.assignedTo?.name || "—"}</span>
            </div>

            <div className="ticket-date">
              {ticket?.createdAt
                ? new Date(ticket.createdAt).toLocaleDateString(
                    lang === "ar" ? "ar-SA" : "en-US",
                  )
                : "-"}
            </div>
            {has("support.ticket.delete") && (
              <Button
                variant="danger"
                appearance=""
                size="sm"
                rounded
                icon={<Trash2 size={16} />}
                aria-label={`${t.deleteTicket}: ${label}`}
                title={t.deleteTicket}
                onClick={(e) => {
                  e.stopPropagation();
                  onDelete?.(ticket);
                }}
              />
            )}

            <span className={`ticket-badge ${ticket?.status}`}>
              {t[ticket?.status] || ticket?.status}
            </span>
          </div>
        );
      })}
    </div>
  );
}
